






















































































































import {defineComponent} from "@vue/composition-api"

export default defineComponent({
  name: "Modal",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  // setup(props) {
  // }
})
